import pages from '../../pages';
import FullWidthLayout from '../../layout/FullWidthLayout';

export default [
  { path: '/finish-sign-up', component: pages.auth.setPhoneAfterSocialAuth, layout: FullWidthLayout },
  { path: '/marketplace', component: pages.onboarding.SelectMarketplace, layout: FullWidthLayout },
  { path: '/onboarding', component: pages.onboarding.Onboarding, layout: FullWidthLayout },
  { path: '/onboarding/:storeId', component: pages.onboarding.Onboarding, layout: FullWidthLayout },
];
